import React from 'react';

import SystemMessage from './SystemMessage';

type Props = {
  text: string
};

class SystemChatMessageOfferAccepted extends SystemMessage<Props> {
  render() {
    const {
      text
    } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('handshake-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-offer-accepted__bubble"
          >
            {text}
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageOfferAccepted;
